<app-dialog-base titleTranslationKey="mobile-upload.qr-dialog.title">
  <ng-container content>
    <div>
      <div class="text-body">{{ locationName }}</div>

      <div class="qr-code">
        <a *ngIf="0" [attr.href]="mobileUploadUrl">Go to mobile upload</a>
        <qrcode *ngIf="!isPending" [width]="200" [qrdata]="mobileUploadUrl" [attr.aria-description]="mobileUploadUrl">
        </qrcode>
        <app-loading-spinner *ngIf="isPending" style="height: 200px; width: 200px"
          loadingHintTranslationKey="mobile-upload.qr-dialog.creation-in-progress" />
      </div>

      <span *ngIf="!isPending" class="text-body">{{ 'mobile-upload.qr-dialog.description' | translate: {
        expirationMinutes: expirationMinutes } }}</span>
    </div>
  </ng-container>

  <ng-container actions>
    <button mat-flat-button color="primary" appAutofocus (click)="closeDialog()" mat-button>
      {{ 'shared.ok' | translate | uppercase }}
    </button>
  </ng-container>
</app-dialog-base>